import { Button, Container, Group, Text } from '@mantine/core';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { Logo } from './common/Logo';
// import logo from '../assets/logo.png';

interface PublicHeaderProps {
	currentSection?: number;
}

export function PublicHeader({ currentSection = 0 }: PublicHeaderProps) {
	const navigate = useNavigate();

	return (
		<Container size="xl" h="100%" px="xs" py="xs">
			<Group justify="space-between" h="100%">
				<Link to="/" style={{ textDecoration: 'none' }}>
					<motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 1 }}>
						<Logo />
					</motion.div>
				</Link>
				<Group gap="xl">
					{/* <Text
						size="sm"
						c={
							currentSection === 2 || currentSection === 3 || currentSection === 4
								? 'white'
								: '#3C3C3C'
						}
						style={{
							cursor: 'pointer',
							transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
							textDecoration: 'underline',
							textUnderlineOffset: '3px',
							textDecorationColor: 'rgba(60, 60, 60, 0.3)',
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.textDecorationColor =
								currentSection === 2 || currentSection === 3 || currentSection === 4
									? 'rgba(255, 255, 255, 0.7)'
									: 'rgba(60, 60, 60, 0.8)';
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.textDecorationColor =
								currentSection === 2 || currentSection === 3 || currentSection === 4
									? 'rgba(255, 255, 255, 0.3)'
									: 'rgba(60, 60, 60, 0.3)';
						}}
						onClick={() => navigate('/signup')}
					>
						Register
					</Text>
					<Button
						variant="filled"
						size="sm"
						onClick={() => navigate('/auth/login')}
						style={{
							background:
								currentSection === 2 || currentSection === 3 || currentSection === 4
									? 'white'
									: '#3C3C3C',
							color:
								currentSection === 2 || currentSection === 3 || currentSection === 4
									? '#3C3C3C'
									: 'white',
							transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
						}}
					>
						Login
					</Button> */}
				</Group>
			</Group>
		</Container>
	);
}
